"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsDialog = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
function PdsDialog(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-dialog", attributes: {
            id: props.id,
            class: props.className,
            'data-return-focus': props.dataReturnFocus,
            'data-is-drawer-mode': react_utils_1.toAttribute(props.dataIsDrawerMode),
            'data-is-large': react_utils_1.toAttribute(props.dataIsLarge)
        }, properties: {
            returnFocusCallback: props.returnFocusCallback
        }, listeners: {
            pdsRemoveDialog: function () {
                props.pdsRemoveDialog();
            }
        } }, props.children));
}
exports.PdsDialog = PdsDialog;

//# sourceMappingURL=pds-dialog.js.map
